import axios from "./_themeInstance"
import {snapshot} from 'valtio'
import store from '@/store'


export default async (themeId: string) => {
    try {
        const storeName = snapshot(store).currentUser?.selectedCompany?.store_name || ''
        const response: any = await axios(`/themes/${themeId}?store_name=${storeName}`)

        return response.data
    } catch (error) {
        return null
    }
}
